<template>
  <div class="home">
    <Banner />
    <HetSection />
    <Footer />
  </div>
</template>

<script>
import Banner from "../components/videodeurbelinbraakonderzoek/Banner.vue";
import HetSection from "../components/videodeurbelinbraakonderzoek/HetSection.vue";
import Footer from "../components/videodeurbelinbraakonderzoek/Footer.vue";
// @ is an alias to /src

export default {
  name: "videodeurbelinbraakonderzoekkHome",
  components: {
    Banner,
    HetSection,
    Footer,
  },
};
</script>
